import React from 'react';
import styled from 'styled-components';
import { IconBase } from '../Base';
const Group = styled.g `
  --wallet-skew: 10deg;
  --wallet-scale: 0.825;

  transform-origin: 0 50%;
  transform: scaleX(var(--wallet-scale)) skewY(var(--wallet-skew)) translateZ(0);
`;
export const IconWallet = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M5.5 1.75C3.42893 1.75 1.75 3.42893 1.75 5.5V6.5L3.25 5.5C3.25 4.25736 4.25736 3.25 5.5 3.25H14.5C15.7426 3.25 16.75 4.25736 16.75 5.5V6.75H14.5V8.25H16.75V12C16.75 13.2426 15.7426 14.25 14.5 14.25V15.75C16.5711 15.75 18.25 14.0711 18.25 12V5.5C18.25 3.42893 16.5711 1.75 14.5 1.75H5.5Z", style: { fill: 'var(--icon-color)' } }),
        React.createElement(Group, null,
            React.createElement("path", { d: "M2.5 5.5C2.5 3.84315 3.84315 2.5 5.5 2.5H14.5C16.1569 2.5 17.5 3.84315 17.5 5.5V12C17.5 13.6569 16.1569 15 14.5 15H5.5C3.84315 15 2.5 13.6569 2.5 12V5.5Z", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)', fill: 'var(--icon-background, none)' } }),
            React.createElement("circle", { cx: "14.25", cy: "8.75", r: "1", style: { fill: 'var(--icon-color)' } }))));
};
//# sourceMappingURL=Wallet.js.map